// This module must be imported before any module that transitively imports
// src/api/crud.js. crud.js captures window.fetch at module load time to guard
// against third-party script (GTM/pixel) corruption. LogRocket also patches
// window.fetch at init time — so we must init before crud.js loads.
import LogRocket from 'logrocket';
import { isProd, isRecognizedTrashieHost } from './config/config';
import { TRASHIE_LOGROCKET_APP_ID } from './components/trashie/config/config';
import { sanitizeFormEncodedBody, sanitizeNetworkBody, sanitizeUrl } from './components/trashie/utils/analytics';

if (isRecognizedTrashieHost()) {
  const sanitizeBody = (body) => {
    try {
      return JSON.stringify(sanitizeNetworkBody(JSON.parse(body)));
    } catch (e) {
      // Not JSON: Firebase's token refresh posts a form-encoded body.
      return sanitizeFormEncodedBody(body);
    }
  };

  LogRocket.init(
    isProd() ? TRASHIE_LOGROCKET_APP_ID.PRODUCTION : TRASHIE_LOGROCKET_APP_ID.STAGING,
    {
      release: process.env.REACT_APP_VERSION,
      // The network sanitizers below only see request/response payloads. URLs
      // were recorded raw, and a recorder captures every navigation — including
      // the `replaceState` a component makes — so a query param carrying PII
      // reached session replay in plain text. See SENSITIVE_QUERY_PARAMS.
      browser: {
        urlSanitizer: sanitizeUrl,
      },
      network: {
        requestSanitizer: (request) => {
          // Same query params as the page URL (see SENSITIVE_QUERY_PARAMS).
          request.url = sanitizeUrl(request.url);
          if (request.headers) {
            request.headers.Authorization = undefined;
            request.headers.authorization = undefined;
          }
          if (request.body) {
            request.body = sanitizeBody(request.body);
          }
          return request;
        },
        responseSanitizer: (response) => {
          if (response.body) {
            response.body = sanitizeBody(response.body);
          }
          return response;
        },
      },
    },
  );
}
